import * as React from 'react'
import Paper from '@mui/material/Paper'
import InputBase from '@mui/material/InputBase'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import SearchIcon from '@mui/icons-material/Search'
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined'
import {FC, useState} from 'react'

type Props = {
  handleFilter?: (data: string) => void
}

export const InputFilterBancas: FC<Props> = ({handleFilter}) => {
  const [value, setValue] = useState('')
  const handleFilterInfo = () => {
    if (handleFilter) handleFilter(value.trim())
  }

  return (
    <Paper component='form' sx={{p: '2px 4px', display: 'flex', alignItems: 'center', width: 400}}>
      <IconButton onClick={handleFilterInfo} type='button' sx={{p: '10px'}} aria-label='search'>
        <SearchIcon />
      </IconButton>
      <InputBase
        sx={{ml: 1, flex: 1}}
        placeholder='Tìm kiếm'
        inputProps={{'aria-label': 'Tìm kiếm'}}
        value={value}
        onChange={(event) => setValue(event.target.value)}
      />
      <Divider sx={{height: '28px !important', m: 0.5}} orientation='vertical' />
      <IconButton
        color='primary'
        sx={{p: '10px'}}
        aria-label='directions'
        id='kt_drawer_chat_toggle'
      >
        <FilterListOutlinedIcon />
      </IconButton>
    </Paper>
  )
}
